import request from './api';
import { API_INTRANET } from '../constants/api';

export const getPressRelease = () =>
  request(`${API_INTRANET}pressreleases?size=24&order=desc`, {
    method: 'GET'
  }).then(response => response);
